import React from 'react';
import { LinkButton } from '../LinkButton/LinkButton';
import type { SeeAllLinkProps } from './types';

/**
 * Secondary list navigation placed under a truncated list, leading to the full list ("Voir les 13
 * autres relances"): the navigation link with a forward chevron. Carries no margin of its own; the
 * parent layout sets the space above it.
 */
export const SeeAllLink: React.FC<SeeAllLinkProps> = (props) => (
    <LinkButton variant="navigation" chevron="end" weight="medium" {...props} />
);
